var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, } from "react-hook-form";
import { TextField } from "@mui/material";
import { useFormLogic } from "../../context/FormLogicContext";
import { getCommentFieldName, resolveTextUpdateMode, } from "../../../../utils/forms-functions";
import { getElementValueKey } from "../../../../utils/helpers";
import { useTextUpdateModeField } from "../../hooks/useTextUpdateModeField";
var CommentAreaInput = function (_a) {
    var field = _a.field, element = _a.element, textUpdateMode = _a.textUpdateMode, fieldMaxLength = _a.fieldMaxLength, commentAreaRows = _a.commentAreaRows, disabled = _a.disabled, autoGrowComment = _a.autoGrowComment;
    var textUpdateModeField = useTextUpdateModeField({
        field: field,
        textUpdateMode: textUpdateMode,
        commitOnEnter: false,
    });
    var rowsProps = autoGrowComment
        ? { minRows: commentAreaRows }
        : { rows: commentAreaRows };
    return (_jsx(TextField, __assign({}, field, textUpdateModeField, { fullWidth: true, sx: {
            mt: "1.5rem",
            "& .MuiInputBase-inputMultiline": {
                resize: autoGrowComment ? "none" : "vertical",
            },
        }, label: element.commentText || "Comentário", placeholder: element.commentPlaceholder, multiline: true }, rowsProps, { helperText: fieldMaxLength ? (_jsx("span", __assign({ style: {
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                width: "100%",
            } }, { children: _jsx("span", { children: "".concat(textUpdateModeField.value.length, "/").concat(fieldMaxLength) }) }))) : null, inputProps: {
            maxLength: fieldMaxLength,
        }, disabled: disabled })));
};
var CommentArea = function (_a) {
    var _b, _c;
    var element = _a.element, disabledProp = _a.disabled;
    var _d = useFormLogic(), globalConstraints = _d.globalConstraints, globalTextUpdateMode = _d.textUpdateMode;
    var fieldMaxLength = (_b = element.maxLength) !== null && _b !== void 0 ? _b : globalConstraints.maxTextLength;
    var commentAreaRows = (_c = globalConstraints.commentAreaRows) !== null && _c !== void 0 ? _c : 4;
    var valueKey = getElementValueKey(element);
    var textUpdateMode = resolveTextUpdateMode(element, {
        textUpdateMode: globalTextUpdateMode,
    });
    return (_jsx(Controller, { name: getCommentFieldName(valueKey), defaultValue: "", render: function (_a) {
            var field = _a.field;
            return (_jsx(CommentAreaInput, { field: field, element: element, textUpdateMode: textUpdateMode, fieldMaxLength: fieldMaxLength, commentAreaRows: commentAreaRows, disabled: disabledProp, autoGrowComment: globalConstraints.autoGrowComment }));
        } }));
};
export default CommentArea;
